export default "__VITE_ASSET__UkEBPe$L__"